import { render } from "./QuestionFormStar.vue?vue&type=template&id=6fc3d5c5&scoped=true&ts=true"
import script from "./QuestionFormStar.vue?vue&type=script&lang=ts"
export * from "./QuestionFormStar.vue?vue&type=script&lang=ts"

import "./QuestionFormStar.vue?vue&type=style&index=0&id=6fc3d5c5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc3d5c5"]])

export default __exports__